/** Copyright 2025 Midas Healthcare Solutions - All Rights Reserved **/
import { HttpContextToken } from '@angular/common/http';

export const SUPPRESS_GLOBAL_ERROR = new HttpContextToken<boolean>(() => false);
